import { mapMutations, mapGetters } from "vuex";

import firebase from "firebase/app";

export default {
  computed: {
    ...mapGetters(["getFitbit", "getUID", "getDB"]),
  },

  methods: {
    ...mapMutations(["setFitbit"]),

    async getTokens() {
      const uid = this.getUID;
      const database = firebase.database();

      // Query DB for existing Fitbit info.
      const query = await database
        .ref("fitbit")
        .orderByChild("uid")
        .equalTo(uid)
        .get();

      const queryData = await query.val();

      // Get the fitbit ID.
      const fitbitID = Object.keys(queryData)[0];

      // Return tokens.
      return queryData[fitbitID];
    },

    async setTokens(tokens) {
      const database = firebase.database();

      await database.ref(`/fitbit/${tokens.user_id}`).set({
        accessToken: tokens.access_token,
        refreshToken: tokens.refresh_token,
        uid: firebase.auth().currentUser.uid,
      });
    },

    async getRefreshToken() {
      const tokens = await this.getTokens();

      const response = await fetch("https://api.fitbit.com/oauth2/token", {
        method: "POST",
        body: new URLSearchParams({
          grant_type: "refresh_token",
          refresh_token: tokens.refreshToken,
          client_id: "23BH8P",
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      return await response.json();
    },

    async getActivity(dateString, token) {
      // Fetch steps from fitbit API.
      const activityURL = `https://api.fitbit.com/1/user/-/activities/date/${dateString}.json`;

      const response = await fetch(activityURL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return await response.json();
    },

    async addFitbitEntry(date, data) {
      // Check for existing entry.
      let exists = false;
      let existingID;

      const existsQuery = await this.getDB
        .collection("logs")
        .where("date", "==", date)
        .where("user", "==", this.getUID)
        .where("module", "==", "steps")
        .get();

      existsQuery.forEach((doc) => {
        if (doc.data()) {
          exists = true;
          existingID = doc.id;
        }
      });

      if (exists) {
        this.getDB
          .collection("logs")
          .doc(existingID)
          .update({
            steps: data.summary.steps,
          });
      } else {
        // Write new steps entry to database.
        this.getDB.collection("logs").add({
          data: {
            steps: data.summary.steps,
          },
          date: date,
          module: "steps",
          user: this.getUID,
        });
      }
    },
  },
};
